export const NOTIFICATION_SEVERITY = {
  CRITICAL: 'critical',
  WARNING: 'warning',
  INFO: 'info',
} as const

export const NOTIFICATION_TYPE = {
  NEW_PACKAGE_VERSION: 'new-package-version',
  DEPRECATED_PACKAGE: 'deprecated-package',
  VULNERABILITY_DETECTED: 'vulnerability-detected',
  HIGH_LATENCY_ALERT: 'high-latency-alert',
  CONNECTION_ERROR: 'connection-error',
  SERVICE_DEGRADED: 'service-degraded',
  SCHEDULED_MAINTENANCE: 'scheduled-maintenance',
  CRITICAL_VULNERABILITY: 'critical-vulnerability',
  UNAUTHORIZED_LOGIN: 'unauthorized-login',
  CERTIFICATE_UPDATE: 'certificate-update',
  INVITED_TO_ORGANIZATION: 'invited-to-organization',
  ROLE_PERMISSION_CHANGE: 'role-permission-change',
  NEW_FEATURE: 'new-feature',
  SYSTEM_ANNOUNCEMENT: 'system-announcement',
  DAILY_DIGEST: 'daily-digest',
  WEEKLY_REPORT: 'weekly-report',
} as const

export const NOTIFICATION_DRAWER_FILTER = {
  ALL: 'all',
  UNREAD: 'unread',
} as const
